export const COMMENTS = 'COMMENTS'
export const SET_ENTITY_ID = 'SET_ENTITY_ID'
export const NOTIFICATIONS = 'NOTIFICATIONS'
export const NOTIFICATIONS_COUNT = 'NOTIFICATIONS_COUNT'
export const IS_LOADED_COMMENTS = 'IS_LOADED_COMMENTS'
export const IS_FROM_NOTIF = 'IS_FROM_NOTIF'
export const NOTIF_LINK = 'NOTIF_LINK'
export const IS_LOADED_ENTITY_ID = 'IS_LOADED_ENTITY_ID'



// WEBPACK FOOTER //
// ./src/store/modules/comments/mutation_types.js